// Mobile grayscale reveal logic
// - /collections (list-collections): touchstart, one card at a time
// - individual collection pages: touchstart, one card at a time
(function () {
  if (window.innerWidth > 749) return;

  document.addEventListener('touchstart', function (e) {
    // Collection list page: target is .collection-card-wrapper
    var collectionCard = e.target.closest(
      '.collection-list .collection-card-wrapper'
    );
    if (collectionCard) {
      collectionCard.closest('.collection-list')
        .querySelectorAll('.collection-card-wrapper.touched')
        .forEach(function (el) { el.classList.remove('touched'); });
      collectionCard.classList.add('touched');
      return;
    }

    // Individual collection page (product grid): target is .card-wrapper
    var productCard = e.target.closest('ul#product-grid .card-wrapper');
    if (productCard) {
      productCard.closest('ul#product-grid')
        .querySelectorAll('.card-wrapper.touched')
        .forEach(function (el) { el.classList.remove('touched'); });
      productCard.classList.add('touched');
    }
  }, { passive: true });

})();
